export function NinValidator (nin:number) {
  const re = /^\d+$/;
  if (re.test(String(nin).toLowerCase()) === true && nin.toString().length === 15) {
    return true
  } else {
    return false
  }
}
